import {IComponentOptions, ILogService} from "angular";
import {Application} from "../../model/Application";
import {ApplicationService} from "../application.service";
import "./application-outcome-comment.less";

class ApplicationOutcomeCommentController {

    private application: Application;
    private editable: boolean;
    private editMode: boolean;
    private outcomeComment: string;
    private processing: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.$log.debug(this.application);

        if (this.application.status === "STUDENT_ACCEPTED" ||
            this.application.status === "STUDENT_DECLINED" ||
            this.application.status === "ARCHIVED") {
            this.editable = false;
        }

        this.outcomeComment = this.application.outcomeComment;
    }

    public setEditMode() {
        this.editMode = true;
    }

    public update(applicationId: string, outcomeComment: string) {
        if (this.outcomeComment === this.application.outcomeComment) {
            this.editMode = false;
            return;
        }

        this.processing = true;
        this.applicationService.updateStudentCreditApplicationOutcomeComment(applicationId, outcomeComment)
            .then((updatedApplication: Application) => {
                this.application = updatedApplication;
            })
            .finally(() => {
                this.processing = false;
                this.editMode = false;
            });
    }

}

export const ApplicationOutcomeCommentComponent: IComponentOptions = {
    bindings: {
        application: "<",
        editable: "<?"
    },
    controller: ApplicationOutcomeCommentController,
    template: require("./application-outcome-comment.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/outcome-comment/application-outcome-comment.component.ts